import React from 'react'
import i18next from 'i18next'
import { Button, Form, Row, Col } from 'react-bootstrap'
import hash from 'object-hash'
import { Trans } from 'react-i18next'
import isEmail from 'validator/lib/isEmail'
import PlaceSelect from '../system_wide/places_select'
import SelectAgentsModal from '../system_wide/select_agents_modal'
import DealerBrands from './dealer_brands'
import StyledSelect from '../system_wide/styled_select'
import DealerContacts from './dealer_contacts'

const { t } = i18next

class DealerForm extends React.Component {
  static defaultProps = {
    dealer: {},
    categories: [],
    brands: [],
    agents: [],
    business_role_priority: null,
    errors: {},
    readonly: false,
    onSave: () => {},
    closeForm: () => {},
    updateErrors: () => {},
  }

  state = {
    id: null,
    business_name: '',
    piva: '',
    commercial_email: '',
    administrative_email: '',
    phone: '',
    address: '',
    city: '',
    province: '',
    cap: '',
    region: '',
    country: '',
    lat: '',
    lng: '',
    place_id: '',
    subcode: true,
    note: '',
    dealer_hash: '',
    agent_id: null,
    agent: null,
    merchandise_category_id: null,
    merchandise_category: null,
    dealer_brands: [],
    contacts: [],
  }

  initialHash = ''
  selectAgentsModalRef = null

  constructor(props) {
    super(props)
    this.selectAgentsModalRef = React.createRef()
    if (props.dealer.id) {
      let {
        id,
        business_name,
        piva,
        commercial_email,
        administrative_email,
        phone,
        address,
        city,
        province,
        cap,
        region,
        country,
        lat,
        lng,
        place_id,
        subcode,
        note,
        agent_id,
        agent,
        merchandise_category_id,
        merchandise_category,
        dealer_brands,
        contacts,
      } = props.dealer
      this.state.id = id
      this.state.business_name = business_name
      this.state.piva = piva
      this.state.commercial_email = commercial_email ? commercial_email : ''
      this.state.administrative_email = administrative_email ? administrative_email : ''
      this.state.phone = phone ? phone : ''
      this.state.address = address
      this.state.city = city
      this.state.province = province
      this.state.cap = cap
      this.state.region = region
      this.state.country = country
      this.state.lat = lat
      this.state.lng = lng
      this.state.place_id = place_id
      this.state.subcode = subcode
      this.state.note = note ? note : ''
      this.state.agent_id = agent_id
      this.state.agent = agent
      this.state.merchandise_category_id = merchandise_category_id
      this.state.merchandise_category = merchandise_category
      this.state.dealer_brands = dealer_brands
      this.state.contacts = contacts
    }

    let { dealer_hash, ...rest } = this.state
    this.initialHash = hash(rest)
    this.state.dealer_hash = this.initialHash
  }

  updateHash = () => {
    let { dealer_hash, ...rest } = this.state
    this.setState({ dealer_hash: hash(rest) })
  }

  handleChange = ({ target: { name, value } }) => {
    let errors = { ...this.props.errors }
    if (name in errors) {
      delete errors[name]
      this.props.updateErrors({ errors })
    }
    this.setState({ [name]: value }, () => this.updateHash())
  }

  handleChangeCheckbox = ({ target: { name } }) => {
    this.setState({ [name]: !this.state[name] }, () => this.updateHash())
  }
  handleSelectChange = (option, { name }) => {
    this.setState({ [name]: option ? option.value : null }, () => this.updateHash())
  }
  handledChangePlace = place => {
    let { label, value, details } = place ?? { label: '', value: '', details: null }
    let { lat = '', lng = '', country = '', region = '', province = '', city = '', cap = '' } = details || {}
    this.setState(
      {
        address: label,
        place_id: value,
        lat,
        lng,
        country,
        region,
        province,
        city,
        cap,
      },
      () => this.updateHash()
    )
  }

  handleConfirm = () => {
    let { dealer_hash, ...rest } = this.state
    this.props.onSave(rest)
  }

  isFormValid = () => {
    let {
      business_name,
      piva,
      commercial_email,
      administrative_email,
      address,
      city,
      province,
      cap,
      region,
      country,
      lat,
      lng,
      place_id,
      agent_id,
      merchandise_category_id,
      dealer_brands,
      contacts,
    } = this.state
    return (
      business_name !== '' &&
      piva !== '' &&
      commercial_email !== '' &&
      isEmail(commercial_email) &&
      (!administrative_email || isEmail(administrative_email)) &&
      address !== '' &&
      city !== '' &&
      province !== '' &&
      cap !== '' &&
      region !== '' &&
      country !== '' &&
      lat !== '' &&
      lng !== '' &&
      place_id !== '' &&
      agent_id !== null &&
      merchandise_category_id !== null &&
      dealer_brands.length > 0 &&
      contacts.length
    )
  }

  componentWillUnmount() {
    this.props.updateErrors({})
  }

  showSelectUserModal = () => {
    this.selectAgentsModalRef.current.show({
      selected_users: [this.state.agent_id],
    })
  }
  handleChangeAgent = user => {
    let { id, first_name, last_name, brands } = user[0]
    this.setState({ agent_id: id, agent: { id, first_name, last_name, brands } }, () => this.updateHash())
  }

  handleDealerBrandsChange = dealer_brands => {
    this.setState({ dealer_brands }, () => this.updateHash())
  }

  handleDealerContactsChange = dealer_contacts => {
    this.setState({ contacts: dealer_contacts }, () => this.updateHash())
  }

  isEmailInvalid = name => {
    return this.state[name] !== '' && !isEmail(this.state[name])
  }

  render() {
    let {
      business_name,
      piva,
      commercial_email,
      administrative_email,
      phone,
      place_id,
      address,
      city,
      province,
      cap,
      region,
      country,
      lat,
      lng,
      subcode,
      note,
      agent_id,
      agent,
      merchandise_category_id,
      dealer_brands,
      contacts,
    } = this.state
    let place_selected = { label: address, value: place_id }
    let categoryOptions = this.props.categories
      .filter(category => category.id === merchandise_category_id || category.is_valid === true)
      .map(c => ({ label: c.name, value: c.id }))
    let selected_category = categoryOptions.find(c => c.value === merchandise_category_id) ?? null
    return (
      <>
        <div className="flex-fill position-relative overflow-auto">
          <div className="container">
            <Row>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.business_name">Nome Azienda</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="business_name"
                  placeholder={t('components.dealers.business_name', 'Nome Azienda')}
                  value={business_name}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                  isInvalid={'business_name' in this.props.errors}
                />
                <Form.Control.Feedback type="invalid">{this.props?.errors?.business_name ?? ''}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.piva">Partita IVA</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="piva"
                  placeholder={t('components.dealers.piva', 'Partita IVA')}
                  value={piva}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                  isInvalid={'piva' in this.props.errors}
                />
                <Form.Control.Feedback type="invalid">{this.props?.errors?.piva ?? ''}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md="4" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.commercial_email">Email Commerciale</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="commercial_email"
                  type="email"
                  placeholder={t('components.dealers.commercial_email', 'Email Commerciale')}
                  value={commercial_email}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                  isInvalid={this.isEmailInvalid('commercial_email')}
                />
                <Form.Control.Feedback type="invalid">
                  <Trans i18nKey="components.dealers.invalid_email">Indirizzo e-mail non valido</Trans>
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md="4" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.administrative_email">Email Amministrativa</Trans>
                </Form.Label>
                <Form.Control
                  name="administrative_email"
                  type="email"
                  placeholder={t('components.dealers.administrative_email', 'Email Amministrativa')}
                  value={administrative_email}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                  isInvalid={this.isEmailInvalid('administrative_email')}
                />
                <Form.Control.Feedback type="invalid">
                  <Trans i18nKey="components.dealers.invalid_email">Indirizzo e-mail non valido</Trans>
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md="4" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.phone">Telefono</Trans>
                </Form.Label>
                <Form.Control
                  name="phone"
                  type="tel"
                  placeholder={t('components.dealers.phone', 'Telefono')}
                  value={phone}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                  isInvalid={'phone' in this.props.errors}
                />
                <Form.Control.Feedback type="invalid">{this.props?.errors?.phone ?? ''}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md="12" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.address">Indirizzo</Trans>
                </Form.Label>
                <span> *</span>
                <PlaceSelect
                  selected={place_selected}
                  includeDetails={true}
                  onChange={this.handledChangePlace}
                  disabled={this.props.readonly}
                />

                <Form.Control.Feedback type="invalid">{this.props?.errors?.address ?? ''}</Form.Control.Feedback>
              </Form.Group>

              {/* Nuovi Campi Aggiunti */}
              <Form.Group as={Col} md="3" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.lat">Latitudine</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="lat"
                  type="text"
                  placeholder={t('components.dealers.lat', 'Latitudine')}
                  value={lat}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>

              <Form.Group as={Col} md="3" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.lng">Longitudine</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="lng"
                  type="text"
                  placeholder={t('components.dealers.lng', 'Longitudine')}
                  value={lng}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>
              <Form.Control.Feedback type="invalid">{this.props?.errors?.address ?? ''}</Form.Control.Feedback>

              <Form.Group as={Col} md="3" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.country">Nazione</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="country"
                  placeholder={t('components.dealers.country', 'Nazione')}
                  value={country}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="3" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.region">Regione</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="region"
                  placeholder={t('components.dealers.region', 'Regione')}
                  value={region}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="5" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.province">Provincia</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="province"
                  placeholder={t('components.dealers.province', 'Provincia')}
                  value={province}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="2" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.cap">CAP</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="cap"
                  placeholder={t('components.dealers.cap', 'CAP')}
                  value={cap}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="5" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.city">Città</Trans>
                </Form.Label>
                <span> *</span>
                <Form.Control
                  name="city"
                  placeholder={t('components.dealers.city', 'Città')}
                  value={city}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-3 align-items-center">
                <Form.Label className="me-2">
                  <Trans i18nKey="components.dealers.subcode">Sottocodice</Trans>
                </Form.Label>
                <Form.Check
                  name="subcode"
                  type="switch"
                  checked={subcode}
                  onChange={this.handleChangeCheckbox}
                  disabled={this.props.readonly}
                  inline
                />
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.category">Categoria merceologica</Trans>
                  <span> *</span>
                </Form.Label>

                <StyledSelect
                  name="merchandise_category_id"
                  isClearable
                  placeholder={t('components.dealers.category', 'Categoria merceologica')}
                  value={selected_category}
                  onChange={this.handleSelectChange}
                  options={categoryOptions}
                  disabled={this.props.readonly}
                />
              </Form.Group>

              <Form.Group as={Col} md="12" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealers.note">Note</Trans>
                </Form.Label>
                <Form.Control
                  name="note"
                  as="textarea"
                  rows={3}
                  placeholder={t('components.dealers.note', 'Note')}
                  value={note}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>
              <Form.Group as={Col} className="mt-3 mb-3">
                <>
                  <Form.Label>
                    <Trans i18nKey="components.dealers.agent">Funzionario</Trans>
                    <span> *</span>
                  </Form.Label>
                  <div className="mt-1 d-flex flex-row align-items-center mb-3">
                    <div className="d-flex flex-row align-items-center">
                      {this.props.readonly === true && (
                        <b>
                          {this.props.dealer?.agent?.first_name ?? ''} {this.props.dealer?.agent?.last_name ?? ''}
                        </b>
                      )}

                      {this.props.readonly === false && (
                        <>
                          {agent_id && (
                            <div className="text-muted me-2">
                              <b>{agent?.first_name ?? ''}</b> <b>{agent?.last_name ?? ''}</b>
                            </div>
                          )}
                          {!agent_id && (
                            <div className="text-muted me-2">
                              <em>
                                {t('components.dealers.no_selected_officer_label', 'Nessun funzionario selezionato')}
                              </em>
                            </div>
                          )}
                          <Button onClick={this.showSelectUserModal}>
                            <i className="fas fa-plus fa-fw text-start me-0"></i>
                            {agent_id && <Trans i18nKey="components.dealers.edit">Modifica</Trans>}
                            {!agent_id && <Trans i18nKey="components.dealers.choose">Seleziona</Trans>}
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                </>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Col>
                <DealerBrands
                  readonly={this.props.readonly}
                  dealerBrands={this.state.dealer_brands}
                  brands={this.props.brands}
                  agent={this.state.agent}
                  onChange={this.handleDealerBrandsChange}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <DealerContacts
                  readonly={this.props.readonly}
                  dealerContacts={contacts}
                  onChange={this.handleDealerContactsChange}
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="border-top pt-2">
          {this.props.readonly === false && (
            <Button
              className="float-end"
              variant="primary"
              disabled={!this.isFormValid() || this.state.dealer_hash === this.initialHash}
              onClick={this.handleConfirm}>
              <Trans i18nKey="buttons.confirm">Conferma</Trans>
            </Button>
          )}

          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
        </div>
        <SelectAgentsModal
          ref={this.selectAgentsModalRef}
          users={this.props.agents}
          readonly={this.props.readonly}
          onChange={this.handleChangeAgent}
          brands={dealer_brands.length > 0 ? dealer_brands.map(b => ({ ...b, id: b.brand_id })) : this.props.brands}
        />
      </>
    )
  }
}

export default DealerForm
